import { useEffect, useState } from "react";
import { RootState, useAppSelector } from "../redux/AppStore";
import DriverLiveLocationMapComponent from "./Map/DriverLiveLocationMapComponent";
import { SHOW_REFERENCE, trackingSettingOn } from "./trackingSettings";
export default function TrackProgressInfo() {
  const trackinginfo = useAppSelector((state: RootState) => state.tracking.trackingdata);
  const trackingNumber = useAppSelector((state: RootState) => state.tracking.trackingNum);
  const isInternal = useAppSelector((state: RootState) => state.tracking.isinternal);
  const postCode = useAppSelector((state: RootState) => state.tracking.userPostCode);
  const driverLcation = useAppSelector((state: RootState) => state.tracking.driverlocation);
  const shipmentStatus = useAppSelector((state: RootState) => state.updateAddress.status);
  const [dates, setDates] = useState<string[]>([]);
  const [cstatus, setCStatus] = useState('');
  const totaldrops = useAppSelector((state: RootState) => state.tracking.total_drops);
  const [rcount, setrcount] = useState('');
  const companyInfo = useAppSelector((state: RootState) => state.tracking.companyinfo);
  useEffect(() => {
    setDates(Object.keys(trackinginfo));
  }, [trackinginfo]);

  useEffect(() => {
    for (let v of dates) {
      for (let d of trackinginfo[v]) {
        setCStatus(d.code_text);
        break;
      }
      break;
    }
  }, [dates])

  useEffect(() => {
    if (totaldrops?.total_drops && Array.isArray(totaldrops.total_drops)) {
      for (let d of totaldrops.total_drops) {
        if ((d.load_identity == trackingNumber || d.shipment_ticket == trackingNumber)) {
          setrcount(d.execution_order);
        }
      }
    }
  }, [totaldrops, trackingNumber])

  const [driverlat, setdriverlat] = useState('');
  const [driverlong, setdriverlong] = useState('');

  useEffect(() => {
    for (let d of driverLcation) {
      if (d.driver_location.length != 0) {
        setdriverlat(d.driver_location.latitude);
        setdriverlong(d.driver_location.longitude);
      }
    }
  }, [driverLcation])
  const countExecutionOrdersBeforeFive = () => {
    let uniqueExecutionOrders = new Set();
    let count = 0;
    if (totaldrops?.total_drops && Array.isArray(totaldrops.total_drops)) {
      for (const drop of totaldrops.total_drops) {
        if (drop.execution_order === rcount) {
          break;
        }
        uniqueExecutionOrders.add(drop.execution_order);
        count++;
      }
    }
    return uniqueExecutionOrders.size;
  };
  const uniqueCount = countExecutionOrdersBeforeFive();
  // BR-1920: the API decides (BR-1881) — fullAccess = it sent the full record. Replaces the 19299 / 186 bypass.
  const fullAccess = useAppSelector((state: RootState) => state.tracking.fullAccess);
  const verified = fullAccess || (postCode != '' && shipmentStatus == true);
  // BR-1929: old-page parity — job type for the location line, the customer's reference for companies that switch
  // it on, and recipient on every event (the delivered block below already shows it next to the consignee).
  const shipmentType = useAppSelector((state: RootState) => state.tracking.shipmentType);
  const customerRef = useAppSelector((state: RootState) => state.tracking.customerRef);
  const showReference = trackingSettingOn(companyInfo, SHOW_REFERENCE) && customerRef.trim() !== '';
  const isFinalWithRecipient = (d: any) => (d.code_text || '').toLowerCase() === 'delivered' &&
    d.shipment_customer_name != '' && d.shipment_customer_name != null &&
    (d.load_identity === trackingNumber || d.shipment_ticket === trackingNumber);
  return (
    <div >
      <div className="bodyTab order-Confirmed">
        <div className="uk-container uk-padding">
          <div className="uk-timeline">
            {dates && dates.map(v => {
              return trackinginfo && trackinginfo[v] && trackinginfo[v]
               .filter(d => d.isvisible == "1" || d.isvisible === undefined || d.isvisible === null || d.isvisible === "")
               .map((d, dIndex) => {
                return (
                  <div className="uk-timeline-item" key={`${v}-${d.shipment_ticket || d.load_identity || dIndex}`}>
                    <div className="uk-timeline-icon">
                      <span className="uk-badge"></span>
                    </div>
                    <div className="uk-timeline-content">
                      <div className="uk-card">
                        <div className="ukBodyContain">
                          <div className="item-container-1">
                            <div className="item_box_1 DT_data">
                              <div className="B-LL">
                                <span className="monthDate">{d.create_date} {d.create_time}</span>
                              </div>
                            </div>
                            <div className="item_box_2">
                              <div className="B-CC">
                                <span className="collect_drop strong_text">
                                  {d.code_text}
                                </span>
                                {(() => {
                                  // BR-1929: as on the old page, a same-day job's location is the stop's street
                                  // (shp_address1 — blanked by the API until the visitor verifies).
                                  const place = (shipmentType === 'SAME' && d.shp_address1) ? d.shp_address1 : d.location;
                                  return (companyInfo.external_carrier_location === '' || companyInfo.external_carrier_location === 'show') && place &&
                                    <div><b>Location:</b> {place}</div>;
                                })()}
                                {d.parcelString &&
                                  <details className="pieces_list">
                                    <summary><b>Pieces:</b> {String(d.parcelString).split(',').filter(p => p.trim() !== '').length}</summary>
                                    <ul>{String(d.parcelString).split(',').filter(p => p.trim() !== '').map((p, i) => <li key={i}>{p.trim()}</li>)}</ul>
                                  </details>
                                }
                                {d.recipient && !isFinalWithRecipient(d) &&
                                  <div><b>Recipient:</b> {d.recipient}</div>
                                }
                                {showReference &&
                                  <div><b>Reference:</b> {customerRef}</div>
                                }
                                <div className="item_box_2A">
                                  <div className="B-CC">
                                    <span className="collect_drop text_drop">
                                      <div></div>
                                      {d.comment != '' &&
                                        <div><b>Comment:</b> {d.comment} </div>
                                      }
                                    </span>
                                  </div>
                                </div>
                                 <div className="item_box_2A">
                                  <div className="B-CC">
                                    <span className="collect_drop text_drop">
                                      <div></div>
                                      {d.tracking_exception != '' &&
                                        <div><b>Exception:</b> {d.tracking_exception} </div>
                                      }
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="item_box_3">
                              <div className="B-RR"></div>
                            </div>
                          </div>
                          {(() => {
                            const ct = (d.code_text || '').toLowerCase();
                            const cc = (d.code || '').toUpperCase();
                            // Consignee / address text stays limited to the final statuses.
                            const showConsigneeText = ct == 'collected' || ct == 'delivered' ||
                              ct == 'delivery return' || ct == 'delivery carded' ||
                              cc == 'DELIVERY_ATTEMPTED' || cc == 'COLLECTION_ATTEMPTED';
                            // POD picture / signature show for ALL statuses that carry them.
                            const canViewPod = verified;
                            const identityMatch = d.load_identity === trackingNumber || d.shipment_ticket === trackingNumber;
                            const hasPicture = d.picture !== undefined && d.picture !== '';
                            const hasSignature = d.signature !== undefined && d.signature !== '';
                            const showImages = canViewPod && (hasPicture || hasSignature);
                            if (!identityMatch || (!showImages && !showConsigneeText)) return null;
                            return (
                              <div className="item-container-2">
                                <div className="item_box_1A DT_data">
                                  <div className="B-LL"></div>
                                </div>
                                <div className="item_box_2A">
                                  <div className="B-CC">
                                    <span className="collect_drop text_drop">
                                      {showConsigneeText && (
                                        ct == 'delivered' && d.shipment_customer_name != '' && d.shipment_customer_name != null ?
                                          <>
                                            {d.recipient != '' && d.shipment_customer_name != '' &&
                                              <><div><b>Consignee:</b> {d.shipment_customer_name}</div><div><b>Recipient:</b> {d.recipient}</div></>
                                            }
                                          </>
                                          :
                                          <>
                                            {d.shipment_customer_name != '' && <div><b>Consignor:</b> {d.shipment_customer_name}</div>} </>
                                      )}
                                      {showConsigneeText && verified && d.shp_address1 != '' && d.shp_postcode != '' &&
                                        <div><b>Address:</b> {d.shp_address1}{d.shp_postcode}</div>
                                      }
                                    </span>
                                  </div>
                                </div>
                                <div className="item_box_3A">
                                  <div className="B-RR">
                                    {canViewPod && hasPicture && (
                                      <span className="imgBox">
                                        <a href={d.picture} target="_blank">
                                          <img src={d.picture} />
                                        </a>
                                      </span>
                                    )}
                                    {canViewPod && hasSignature && (
                                      <span className="imgBox">
                                        <a href={d.signature} target="_blank">
                                          <img src={d.signature} />
                                        </a>
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })()}
                          {d.code_text === "Out For Delivery" &&
                            verified &&
                            isInternal == 1 &&
                            driverlat.length != 0 &&
                            driverlong.length != 0 && (
                              <>
                                {uniqueCount != 0 && (
                                  <div className="item-container-2 container_space">
                                    <div className="item_box_1A DT_data">
                                      <div className="B-LL"></div>
                                    </div>
                                    <div className="item_box_2A items_space">
                                      <div className="B-CC">
                                        <span className="collect_drop text_drop">
                                          {uniqueCount} jobs ahead
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                <DriverLiveLocationMapComponent />
                              </>
                            )}


                        </div>
                      </div>
                    </div>
                  </div>
                )
              })
            })
            }
          </div>
        </div>
      </div>

    </div >
  );

}
